module.exports = __webpack_public_path__ + "static/media/islempenywis_picture.31e4862f.jpg";